import { Injectable } from '@angular/core';
import { JfkConfig } from '../types/jfkConfig.types';

@Injectable()
export class IntegrationService {
  private applicationPath: string;
  private firmName: string;
  private jfkConfig: JfkConfig = new JfkConfig('', '', '', '', '', '');
  private environment: string;
  private firmId: string;
  private userId: string;
  private sessionId: string;
  private context: string;
  private isEmployee: boolean;

  constructor() {}

  showSpinner = (target: string) => {
    const show = document.getElementById(target);
    if (show !== null && show !== undefined) {
      show.style.display = 'block';
    }
  };

  hideSpinner = (target: string) => {
    const hide = document.getElementById(target);
    if (hide !== null && hide !== undefined) {
      hide.style.display = 'none';
    }
  };

  setApplicationPath(applicationPath: string): void {
    this.applicationPath = applicationPath;
  }

  getApplicationPath(): string {
    return this.applicationPath;
  }

  setFirmName(firmName: string): void {
    this.firmName = firmName;
  }

  getFirmName(): string {
    return this.firmName;
  }

  setFirmId(firmId: string): void {
    this.firmId = firmId;
  }

  getFirmId(): string {
    return this.firmId;
  }

  setUserId(userId: string): void {
    this.userId = userId;
  }

  getUserId(): string {
    return this.userId;
  }

  getSessionId(): string {
    return this.sessionId;
  }

  setSessionId(sessionId: string): void {
    this.sessionId = sessionId;
  }

  getContext(): string {
    return this.context;
  }

  setContext(context: string): void {
    this.context = context;
  }

  getJFKConfig(): JfkConfig {
    return this.jfkConfig;
  }

  setJFKConfig(jfkConfig: any, serviceRegistryConfig: any): void {
    this.jfkConfig = new JfkConfig(
      jfkConfig.jfkUrl,
      jfkConfig.jfkEnvHeader,
      jfkConfig.channelCode,
      serviceRegistryConfig.sacAipExperienceApiConfig.serviceKey,
      serviceRegistryConfig.sacAipExperienceApiConfig.portName,
      serviceRegistryConfig.sacAipExperienceApiConfig.interface
    );
  }

  setEnvironment(value: string): void {
    this.environment = value;
  }

  getEnvironment(): string {
    return this.environment || '';
  }

  setIsEmployee(isEmployee: boolean): void {
    this.isEmployee = isEmployee;
  }

  getIsEmployee(): boolean {
    return this.isEmployee || false;
  }
}
